/* eslint-disable no-console */
import { UserInfo } from 'app/types/auth.types'
import Keycloak from 'keycloak-js'
import { config as ampApiConfig } from '@amplify/amp-api'

import { iFrameKCConfig } from 'app/utils/iframe'
import EnvConstants, {
  keycloakConfig,
  keycloakInitConfig,
} from './config.service'

class AuthApi {
  _keycloakClient: Keycloak | null = null
  private tokenRefreshInterval!: number

  private configureAmpApi = () => {
    ampApiConfig.set('gateway', EnvConstants.API_BASE)
    ampApiConfig.set('sessionExpiredCallback', this.logout)
  }

  async initForDesmosIframe({ token, refreshToken, clientId }: iFrameKCConfig) {
    this._keycloakClient = new Keycloak({
      ...keycloakConfig,
      clientId,
    })

    const keycloakInitWithTokenConfig = {
      token,
      refreshToken,
      checkLoginIframe: false,
      enableLogging: true,
    }

    try {
      await this._keycloakClient.init(keycloakInitWithTokenConfig)
      await this._keycloakClient.loadUserProfile()

      window.kc = this._keycloakClient
      this.configureAmpApi()
    } catch (e) {
      return this._keycloakClient.logout()
    }

    this.tokenRefreshInterval = window.setInterval(async () => {
      try {
        const refreshed = await this.updateToken()
        if (refreshed) {
          const event = new CustomEvent('tokenRefreshed')
          window.dispatchEvent(event)
        }
      } catch {
        clearInterval(this.tokenRefreshInterval)
        this.logout()
      }
    }, 5000)
  }

  async init() {
    this._keycloakClient = new Keycloak(keycloakConfig)

    try {
      await this._keycloakClient.init(keycloakInitConfig)
      await this._keycloakClient.loadUserProfile()

      window.kc = this._keycloakClient
      this.configureAmpApi()
    } catch (e) {
      return this._keycloakClient.logout()
    }

    this.tokenRefreshInterval = window.setInterval(async () => {
      try {
        const refreshed = await this.updateToken()
        if (refreshed) {
          const event = new CustomEvent('tokenRefreshed')
          window.dispatchEvent(event)
        }
      } catch {
        clearInterval(this.tokenRefreshInterval)
        this.logout()
      }
    }, 5000)
  }

  getKc() {
    return this._keycloakClient ?? ({} as Keycloak)
  }

  getCurrentUser() {
    return this._keycloakClient?.loadUserInfo() as unknown as Promise<UserInfo>
  }

  getParsedToken() {
    return this._keycloakClient?.tokenParsed ?? {}
  }

  getAccessToken() {
    return this._keycloakClient?.token ?? ''
  }

  updateToken() {
    // if token expires within 30 seconds - refresh it
    return this._keycloakClient?.updateToken(30)
  }

  getUserBk() {
    return this._keycloakClient?.subject ?? ''
  }

  getRoles() {
    return this._keycloakClient?.realmAccess?.roles ?? []
  }

  logout = () => {
    this._keycloakClient?.logout()
  }

  logoutTo = (url: string) => {
    this._keycloakClient?.logout({ redirectUri: url })
  }
}

export default new AuthApi()
